import classNames from 'classnames';
import { useCallback } from 'react';
import SortingArrows from 'components/common/Grid/Cells/SortingArrows';
import { IGridHeaderCellProps, HeaderClickEvent } from '../types';

import cellStyles from './styles.module.scss';

const GridHeaderCell = ({
  column, onClick, sorting, onSortingChange,
}: IGridHeaderCellProps) => {
  const { isSortable, columnName } = column.header;
  const isSortableColumn = isSortable && columnName;
  const isSorted = isSortableColumn && sorting?.orderBy === column.dataKey;
  const { cellRender, className } = column.header;

  const cellClickHandler = useCallback((event: HeaderClickEvent) => {
    if (onClick) { onClick(event, column); }
    if (onSortingChange) { onSortingChange(event, column); }
  }, [sorting, column]);

  if (cellRender) {
    return (
      <th
        className={classNames(
          cellStyles.commonCell,
          cellStyles.commonHeaderCell,
          cellStyles.sortableHeadCell,
          className,
          { [cellStyles.withAction]: isSortableColumn },
        )}
        onClick={cellClickHandler}
      >
        <div>
          {cellRender()}
          {isSortableColumn && (
            <SortingArrows
              direction={isSorted ? sorting?.direction : undefined}
            />
          )}
        </div>
      </th>
    );
  }

  return (
    <th
      className={classNames(
        cellStyles.commonCell,
        cellStyles.commonHeaderCell,
        className,
        { [cellStyles.withAction]: isSortableColumn },
      )}
      onClick={cellClickHandler}
    >
      <span>
        <span>{column.header.columnName}</span>
        {isSortableColumn && (
          <SortingArrows
            direction={isSorted ? sorting?.direction : undefined}
          />
        )}
      </span>
    </th>
  );
};

export default GridHeaderCell;
